import {FBFieldBaseOptions} from "./FBFieldBase.options";
import {FBFieldWithPriceBase} from "FormBuilder/Fields/Core/FBFieldWithPriceBase";
import {FBFieldWithPriceBaseOptions, PriceTypeEnum} from "FormBuilder/Fields/Core/FBFieldWithPriceBase.Options";
import {StoreDataType} from "shared/core/Store/StoreBase";
import {OptionItem, AdditionalOptionColumn} from "FormBuilder/Fields/Options/OptionItem";

export class FBMultipleOptionsBaseOptions extends FBFieldWithPriceBaseOptions{
    @StoreDataType(OptionItem)
    public Options:OptionItem[];

    @StoreDataType(AdditionalOptionColumn)
    public AdditionalOptionColumn:AdditionalOptionColumn[];


    protected LoadDefaultValues() {
        super.LoadDefaultValues();
        this.Options=[];

        this.Options=[

            new OptionItem().Merge({Id:1, PriceType:PriceTypeEnum.fixed_amount,SalePrice:'',RegularPrice:'',Label:'Option 1'}),
            new OptionItem().Merge({Id:2, PriceType:PriceTypeEnum.fixed_amount,SalePrice:'',RegularPrice:'',Label:'Option 2'}),
            new OptionItem().Merge({Id:3, PriceType:PriceTypeEnum.fixed_amount,SalePrice:'',RegularPrice:'',Label:'Option 3'})
        ];
        this.AdditionalOptionColumn=[];
    }

}

